import React from "react";
import {Config} from '../Config';
import * as Utils from '../inc/Utils';
import {NavLink, useNavigate, useParams} from "react-router-dom";
import bannerImage from "../img/thumb/photo-1920x156.jpg";
import IconSuccess from "../img/icons/icon-check.svg";
import toast, { Toaster } from 'react-hot-toast';
import { loadCaptchaEnginge, LoadCanvasTemplate, validateCaptcha } from 'react-simple-captcha';
import moment from "moment-timezone";
import {confirmAlert} from "react-confirm-alert";

export default function Forgot(prop) {
    let navigate = useNavigate();
    let {slug} = useParams();

    let [disabledBtn, setDisabledBtn] = React.useState(false);

    let refEmail = React.useRef();
    let refCaptcha = React.useRef();

    React.useEffect(() => {
        document.title = 'ลืมรหัสผ่าน | NCSA';

        if(prop.member) {
            navigate((prop.lang === 'en' ? '/en':'/') + 'profile');
        }

        loadCaptchaEnginge(6, '#2A2B71', '#FFFFFF');

        (async function() {
            try {
            } catch (e) {
                //
            }
        })();
    }, []);

    const onSubmit = async () => {
        let email = refEmail.current.value;
        let captcha = refCaptcha.current.value;

        if(email === '' || !Utils.validateEmail.test(email)) {
            toast.error(prop.lang === 'en' ? 'Please specify a valid email':'กรุณาระบุ รูปแบบอีเมลให้ถูกต้อง');
            refEmail.current.focus();
        }
        else if(validateCaptcha(captcha, true) === false) {
            toast.error(prop.lang === 'en' ? 'Captcha Does Not Match':'กรุณาระบุ อักษรภาพที่เห็น ให้ถูกต้อง');
            refCaptcha.current.focus();
        }
        else {
            confirmAlert({
                title: 'แจ้งเตือน',
                message: 'ยืนยันการส่งเมล ?',
                buttons: [
                    {
                        label: 'ตกลง',
                        onClick: async () => {
                            setDisabledBtn(true);
                            let code = Utils.random5Number;
                            let datetime = moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss');
                            let param = {
                                email: email,
                                requestPasswordCode: code,
                                requestPasswordAt: datetime
                            };
                            const result = await checkForgot(param);
                            if(result) {
                                setDisabledBtn(false);
                                if(result.status === 'success') {
                                    const sendMember = await sendEmail({
                                        name: result.fullname,
                                        email: email,
                                        code: code,
                                        datetime: datetime
                                    });
                                    const sendAdmin = await sendEmailAdmin({
                                        email: email,
                                        email_admin: result.email_admin,
                                        datetime: datetime,
                                    });
                                    if(sendMember.status === 1 && sendAdmin.status === 1) {
                                        navigate((prop.lang === 'en' ? '/en':'/') + 'forgot/success');
                                    }
                                    else {
                                        toast.error(prop.lang === 'en' ? 'Sorry, Unable to send email at this time':'ขออภัย ไม่สามารถส่งอีเมลได้ในขณะนี้');
                                    }
                                }
                                else if(result.status === 'email') {
                                    toast.error(prop.lang === 'en' ? 'Email not found':'ไม่พบอีเมลนี้ในระบบ');
                                }
                                else if(result.status === 'delete_account') {
                                    toast.error(prop.lang === 'en' ? 'Sorry, this account is in Deleted status. Please contact the administrator.':'ขออภัย บัญชีนี้อยู่ในสถานะ ลบบัญชี กรุณาติดต่อผู้ดูแลระบบ');
                                }
                                else {
                                    toast.error(prop.lang === 'en' ? 'Sorry, there is a problem. Please contact the administrator':'ขออภัยมีเหตุขัดข้อง กรุณาติดต่อผู้่ดูแลระบบ');
                                }
                            }
                            else {
                                toast.error(prop.lang === 'en' ? 'Sorry, Service is not available at this time. Please contact the administrator.':'ขออภัย ทำรายการได้ในขณะนี้ กรุณาติดต่อผู้่ดูแลระบบ');
                            }
                        }
                    },
                    {
                        label: 'ยกเลิก',
                        onClick: () => {}
                    }
                ]
            });
        }
    };

    async function checkForgot(param) {
        const response = await fetch(Config.apiUrl +'/member/checkForgot', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(param)
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function sendEmailAdmin(param) {
        const response = await fetch(Config.phpUrl +'/email_forgot_admin.php', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(param)
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function sendEmail(param) {
        const response = await fetch(Config.phpUrl +'/email_forgot.php', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(param)
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    return (
        <>
            <div className={"section section-banner small" + (slug === 'success' ? ' d-none':'' )}>
                <img src={bannerImage} alt="" />
                <div className="container">
                    <h1 className="h2 textrow">
                        <span data-aos="fade-up">{prop.lang === 'en' ? 'Forgot Password':'ลืมรหัสผ่าน'}</span>
                    </h1>
                    <p data-aos="fade-in"><NavLink to="/">{prop.lang === 'en' ? 'Home':'หน้าแรก'}</NavLink> / {prop.lang === 'en' ? 'Forgot Password':'ลืมรหัสผ่าน'} </p>
                </div>
            </div>

            <div className="section">
                <div className="container py-2">
                    <div className="card-infos has-shadow-black w-480" data-aos="fade-in">
                        <div className="hgroup text-center" data-aos="fade-in">
                            <h2 className="my-2">{prop.lang === 'en' ? 'Forgot Password':'ลืมรหัสผ่าน'}</h2>
                        </div>

                        <div className={"boxed mt-4" + (slug === 'success' ? ' d-none':'' )}>
                            <div className="row g-3">
                                <div className="col-12">
                                    <div className="form-group">
                                        <h6>{prop.lang === 'en' ? 'Email':'ชื่ออีเมลผู้ใช้งาน'} <span className="star">*</span></h6>
                                        <input type="email" className="form-control" ref={refEmail} placeholder="your@email.com" />
                                    </div>
                                </div>

                                <div className="col-12 mt-4">
                                    <LoadCanvasTemplate reloadText={prop.lang === 'en' ? 'Refresh':'เรียกใหม่'} />
                                </div>
                                <div className="col-12 mt-0">
                                    <div className="form-group">
                                        <input type="text" className="form-control" ref={refCaptcha} placeholder={prop.lang === 'en' ? 'Please input captcha':'ระบุอักษรที่เห็น'} maxLength={6} />
                                    </div>
                                </div>
                            </div>

                            <div className="buttons gap-15 pb-0 mt-0 mb-4">
                                <button className="btn btn-primary w-100" type="button" onClick={onSubmit} disabled={disabledBtn}>
                                    {prop.lang === 'en' ? 'Send Email':'ส่งอีเมล'}
                                </button>
                            </div>

                            <div className="row">
                                <div className="col-6">
                                    <NavLink to={prop.lang === 'en' ? '/en/register':'/register'} className="link-gray">{prop.lang === 'en' ? 'Register':'ลงทะเบียนใช้งาน'}</NavLink>
                                </div>
                                <div className="col-6 text-end">
                                    <NavLink to={prop.lang === 'en' ? '/en/login':'/login'} className="link-gray">{prop.lang === 'en' ? 'Login':'เข้าสู่ระบบ'}</NavLink>
                                </div>
                            </div>
                        </div>

                        <div className={"boxed text-center" + (slug === 'success' ? '':' d-none' )}>
                            <div className="hgroup text-center mb-4" data-aos="fade-in">
                                <div className="my-sm-4">
                                    <img src={IconSuccess} width="100px" height="100px" />
                                </div>
                                <h2 className="my-2 mb-0">{prop.lang === 'en' ? 'A confirmation link has been sent to your email.':'ส่งลิ้งค์ยืนยันไปยังอีเมลของท่านแล้ว'}</h2>
                                <p className="fs-18 fw-500 text-black">{prop.lang === 'en' ? 'Please check your email and click the confirmation link to return and change your password':'กรุณาตรวจสอบอีเมลของท่านแล้วคลิกลิ้งค์ยืนยัน เพื่อกลับเข้ามาเปลี่ยนรหัสผ่านของท่านใหม่'}</p>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <Toaster position="top-right" />
        </>
    );
} 